import type { ActivityCategory } from "@travelix/core";
import { ACTIVITY_CATEGORIES } from "@/lib/activity-categories";
import { cn } from "@/lib/utils";

/**
 * Single-select category picker. Wraps to multiple lines on narrow
 * viewports so the whole set stays visible without horizontal scroll.
 * Passing `null` for value clears the selection; clicking the active
 * pill also clears it (so a mis-tagged event can be untagged).
 */
export function CategoryPicker({
  value,
  onChange,
}: {
  value: ActivityCategory | null;
  onChange: (next: ActivityCategory | null) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {ACTIVITY_CATEGORIES.map((c) => {
        const active = value === c.id;
        const Icon = c.icon;
        return (
          <button
            key={c.id}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(active ? null : c.id)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold transition-colors",
              active
                ? "text-ink"
                : "border border-line text-ink-muted hover:text-ink",
            )}
            style={
              active
                ? { backgroundColor: c.softColor, color: c.color }
                : undefined
            }
          >
            <Icon className="h-3.5 w-3.5" />
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
